<ng-container *ngIf="!show">
  <ng-content></ng-content>
</ng-container>
<div class="spinner" [ngClass]="{'no-margins': margins === false}" *ngIf="show">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
